import Callback from '../../../core/module/callback'
import Line from './line'
import About from './about'

export default {
    Line,
    About,
    Callback
}